import loadable from '@loadable/component';

const MainPageLoadable = loadable(() => import('../Pages/MainPage'));

export const RootApplicationContainer = () => {
  return <MainPageLoadable />;
};
